module.exports = __webpack_public_path__ + "static/img/3.267b95c.jpg";